import { render, staticRenderFns } from "./PersonalStatement.vue?vue&type=template&id=0aa5403c&"
import script from "./PersonalStatement.vue?vue&type=script&lang=js&"
export * from "./PersonalStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports